import {Tooltip} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #E6E8ED",
        },
        color: theme.palette.common.white,
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: "1px solid #E6E8ED",
        color: "#4A4A4A",
    },
}));

function SecurityPopover({icon, secret, onChangeSecret}) {
    let classes = useStyles();
    return (
        <Tooltip
            arrow
            classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
            title={
                <div className="flex flex-row-reverse items-center px-1">
          <span
              className={`${
                  secret ? "bg-[#24AF22]" : "bg-[#c4c4c4]"
              } relative inline-flex rounded-full h-3 w-3 ml-2`}
          ></span>

                    <span className={`${secret ? "text-[#1A1919]" : "text-[#424242]"} text-base`}>
            {secret ? ".حالت امنیتی فعال است" : ".حالت امنیتی غیر فعال است"}
          </span>
                </div>
            }
        >
            <div className="px-4 ">
                <button onClick={() => onChangeSecret()} className="bg-white py-2  ">
                    {icon}
                </button>
            </div>
        </Tooltip>
    );
}

export default SecurityPopover;
